export default __webpack_public_path__ + "static/media/img-box-2.6332b4ca.jpg";